import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-remark-modal",
  templateUrl: "./remark-modal.component.html",
  styleUrls: ["./remark-modal.component.scss"],
})
export class RemarkModalComponent {
  textareaValue: string = "";
  constructor(
    public dialogRef: MatDialogRef<RemarkModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { required: boolean; heading: string; prefix?: string }
  ) {}

  ngOnInit() {
    if (this.data.prefix) {
      this.textareaValue = this.data.prefix;
    }
  }
  submit() {
    if (this.data.required && !this.textareaValue.trim()) {
      return;
    }

    this.dialogRef.close(this.textareaValue);
  }

  back() {
    this.dialogRef.close(null);
  }
}
